import React from 'react';
import { InboxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon?: typeof InboxIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}
export function EmptyState({
  icon: Icon = InboxIcon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="rounded-xl border border-dashed border-stone-300 bg-white px-6 py-14 text-center" data-id="element-84" data-mp="tj1jsajycwnq">
      <Icon className="mx-auto h-7 w-7 text-stone-300" aria-hidden data-id="element-85" data-mp="18fiur0o8c99r" />
      <p className="mt-3 text-sm font-semibold text-stone-900" data-id="element-86" data-mp="18dpm5fu23ez4">{title}</p>
      {description && <p className="mx-auto mt-1 max-w-sm text-sm text-stone-500" data-id="element-87" data-mp="13f4wubgcefpg">
          {description}
        </p>}
      {action && <div className="mt-5" data-id="element-88" data-mp="1d70ytxljupyy">{action}</div>}
    </div>;
}